import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkTopologyMap from './containers/NetworkTopologyMap';
import { NETWORK_TOPOLOGY } from '../../constants';

interface Props {
}

const NetworkTopology: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${NETWORK_TOPOLOGY}`}>
        <NetworkTopologyMap />
      </Route>
    </Fragment>
  );
};

export default NetworkTopology;
